import { FormControlBase } from './form-control-base.model';
import { FormControlOptions } from '../../../../app/shared/interfaces/form-control-options.interface';
import { FormControlType } from '../../enums/form-control-type.enum';


export class FormControlBoolean extends FormControlBase<boolean> {
  formControlType: FormControlType = FormControlType.INPUT;
  inputType = 'checkbox';

  constructor(options: FormControlOptions<boolean>) {
    super(options);
  }
}
